import { z } from 'zod';

/**
 * Outgoing notifications are written to the notification_outbox table in the SAME transaction
 * as the change that caused them, then sent to SQS after commit. The notify Lambda sends email via SES.
 */
export const NOTIFICATION_KINDS = ['test', 'alert', 'digest'] as const;

export const notificationMessageSchema = z.object({
  notificationId: z.uuid(),
  kind: z.enum(NOTIFICATION_KINDS),
  to: z.array(z.email()).min(1).max(50),
  subject: z.string().min(1).max(200),
  text: z.string().min(1).max(20_000),
});
export type NotificationMessage = z.infer<typeof notificationMessageSchema>;
